var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('SideBar',{attrs:{"lineInfo":_vm.lineInfo}}),_c('Mapbox',{attrs:{"nav-control":{
      show: false,
      position: 'top-right'
    },"geolocate-control":{
      show: false,
      position: 'top-left'
    },"scale-control":{
      show: false,
      position: 'top-left'
    },"fullscreen-control":{
      show: false,
      position: 'top-left'
    },"access-token":"pk.eyJ1IjoiZGVuZzIzIiwiYSI6ImNqNzhzZWFrMzI1aTMycXRjZmcyajVoOTYifQ.3RPzqTzCv20cZMQLYVlqIQ","map-options":{
      style: 'mapbox://styles/deng23/cjratwtse1zj52spdvb6lm6oy'
    }},on:{"map-mousemove":_vm.mouseMove}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }